import injectSheet from 'react-jss'
import SearchResult from './SearchResult'
import styles from './SearchResult.styles'

export default injectSheet(styles)(SearchResult)
